import PropTypes from "prop-types";

import checkinWalkaroundGuide from "../../../assets/img/checkin/checkin.svg";

const CheckInInstructions = ({ t, flowType = "checkin" }) => {
    const isCheckout = flowType === "checkout";

    return (
    <div>
        <h2 className="fontSemi mb-2 text-lg text-[#101828]">
            {isCheckout ? t("returnVehicle") : t("photographVehicle")}
        </h2>
        <p className="fontRegular mb-4 text-sm text-[#667085]">
            {isCheckout ? t("returnVehicleDescription") : t("vehiclePhotographDescription")}
        </p>

        <div className="flex flex-col gap-6 rounded-2xl border border-[#E6EAF2] bg-white p-6 sm:flex-row">
            <div className="relative mx-auto w-48 flex-shrink-0 sm:mx-0">
                <img src={checkinWalkaroundGuide} alt="Car walkaround guide" className="h-auto w-full" />
            </div>

            <div className="flex flex-1 flex-col justify-center">
                <p className="fontRegular text-sm leading-relaxed text-[#667085]">
                    {isCheckout ? t("returnInstructions") : t("photographInstructions")}
                </p>
            </div>
        </div>
    </div>
    );
};

CheckInInstructions.propTypes = {
    t: PropTypes.func.isRequired,
    flowType: PropTypes.oneOf(["checkin", "checkout"]),
};

export default CheckInInstructions;
